import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';
import Link from '../Link';

const { podiumCdsColorFocusRing } = nike;

export const searchSuggestionLinkAndButton = 'search-suggestion-link-and-button';
export const accessibilityButton = 'accessibility-button';

export const StyledListItem = styled.li`
  padding: var(--podium-cds-size-spacing-s) 0;
  ${props =>
    props.isSelected &&
    `
    a:focus-visible,
    a:focus,
    a:hover {
      box-shadow: 0 0 0 2px ${podiumCdsColorFocusRing};
    }
  `}

  .${accessibilityButton} {
    opacity: 0;
    svg {
      width: 12px;
    }
    &:focus {
      opacity: 1;
      transition: transform ease, opacity 500ms;
    }
  }

  .${searchSuggestionLinkAndButton} {
    display: flex;
  }
`;

export const StyledLink = styled(Link)`
  width: fit-content;
  display: block;
  outline: none;
  border-radius: var(--podium-cds-size-border-radius-s);
`;
